import { StrictDict } from 'utils';

import app from './app';
import download from './download';
import grading from './grading';

export default StrictDict({
  app,
  download,
  grading,
});
